import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { Modal, Button, Form } from "react-bootstrap";
import AdminHeader from "../../common/AdminHeader";
import Footer from "../../common/Footer";
import { baseUrl } from "../../../Utility/constants";

const HolidayMaster = ({ title }) => {
  const [list, setList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [model, setModel] = useState({
    id: 0,
    name: "",
    holidayDate: "",
    isActive: true,
  });

  const apiUrl = `${baseUrl}/api/HolidayMaster`;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get(apiUrl);
      setList(res.data);
    } catch (err) {
      toast.error("Failed to load holidays");
    }
  };

  const handleShowModal = (item = null) => {
    if (item) {
      setModel({
        id: item.id,
        name: item.name,
        holidayDate: item.holidayDate?.split("T")[0], // important for date input
        isActive: item.isActive,
      });
      setIsEdit(true);
    } else {
      setModel({
        id: 0,
        name: "",
        holidayDate: "",
        isActive: true,
      });
      setIsEdit(false);
    }
    setShowModal(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setModel({
      ...model,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    if (!model.name.trim() || !model.holidayDate) {
      toast.warning("Please fill all fields");
      return;
    }

    try {
      if (isEdit) {
        await axios.put(`${apiUrl}/${model.id}`, model);
        toast.success("Holiday updated successfully");
      } else {
        await axios.post(apiUrl, model);
        toast.success("Holiday added successfully");
      }

      fetchData();
      setShowModal(false);
    } catch (err) {
      toast.error(err.response?.data || "Failed to save record");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    try {
      await axios.delete(`${apiUrl}/${id}`);
      toast.success("Holiday deleted successfully");
      fetchData();
    } catch {
      toast.error("Failed to delete record");
    }
  };

  return (
    <>
      <AdminHeader />

      <div className="container mt-5">
        <div className="d-flex justify-content-between mb-3">
          <h4>{title}</h4>
          <Button onClick={() => handleShowModal()}>Add Holiday</Button>
        </div>

        <table className="table table-bordered table-striped">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Date</th>
              <th width="160">Actions</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center">
                  No records found
                </td>
              </tr>
            )}

            {list.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.name}</td>
                <td>{new Date(item.holidayDate).toLocaleDateString()}</td>
                <td>
                  <Button
                    size="sm"
                    variant="warning"
                    className="me-2"
                    onClick={() => handleShowModal(item)}
                  >
                    Edit
                  </Button>
                  <Button
                    size="sm"
                    variant="danger"
                    onClick={() => handleDelete(item.id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEdit ? "Edit Holiday" : "Add Holiday"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Holiday Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={model.name}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                name="holidayDate"
                value={model.holidayDate}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={handleSubmit}>
            {isEdit ? "Update" : "Save"}
          </Button>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
      <ToastContainer />
    </>
  );
};

export default HolidayMaster;
